module.exports = __webpack_public_path__ + "static/media/foul.da20a969.jpg";